import { Injectable, EventEmitter } from "@angular/core";
import { KreTableFieldConfig, KreFormFieldConfig } from "@kre-form/core";
import * as _ from "lodash";
@Injectable()
export class KreSetFormFieldService {
  constructor() {}

  getKreFiledFunction(field: KreFormFieldConfig) {
    let fieldSource: KreFormFieldConfig[] = this.getSourceFields(field);
    let fields: KreFormFieldConfig[] = [];
    let type = field.type;
    switch (type) {
      case "text":
        fields = this.text(field);
        break;
      case "texti18n":
        fields = this.textI18N(field);
        break;
      case "textarea":
        fields = this.textArea(field);
        break;
      case "numbers":
        fields = this.number(field);
        break;
      case "password":
        fields = this.passWord(field);
        break;
      case "radio":
        fields = this.radio(field);
        break;
      case "radiogroup":
        fields = this.radio(field);
        break;
      case "checkbox":
        fields = this.checkbox(field);
        break;
      case "checkboxgroup":
        fields = this.checkbox(field);
        break;
      case "select":
        fields = this.select(field);
        break;
      case "datetime":
        fields = this.datetime(field);
        break;
      case "image":
        fields = this.image(field);
        break;
      case "upload":
        fields = this.upload(field);
        break;
      case "htmlcontent":
        fields = this.html(field);
        break;
      case "lookup":
        fields = this.lookup(field);
        break;
      case "repeat":
        fields = this.repeat(field);
        break;
      case "dimissContract":
        fields = this.dimissContract(field);
        break;
    }
    fields.push({
      key: "templateOptions.pattern",
      type: "textarea",
      templateOptions: {
        label: "正则表达式",
        rows: 4,
      },
      defaultValue: _.get(field, "templateOptions.pattern"),
    });
    fieldSource = [...fieldSource, ...fields];
    return fieldSource;
  }

  private getSourceFields(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "key",
        type: "text",
        templateOptions: {
          label: "字段编码",
        },
        editor: false,
        defaultValue: field["key"],
      },
      {
        key: "templateOptions.label",
        type: "text",
        templateOptions: {
          label: "显示名称",
        },
        editor: false,
        defaultValue: _.get(field, "templateOptions.label"),
      },
      {
        key: "type",
        type: "text",
        templateOptions: {
          label: "字段类型",
        },
        editor: false,
        defaultValue: field["type"],
      },
      {
        key: "defaultValue",
        type: "text",
        templateOptions: {
          label: "默认值",
        },
        editor: false,
        defaultValue: field["defaultValue"],
      },
      {
        key: "templateOptions.tips",
        type: "text",
        templateOptions: {
          label: "提示信息",
        },
        editor: false,
        defaultValue: _.get(field, "templateOptions.tips"),
      },
      {
        key: "templateOptions.placeholder",
        type: "text",
        templateOptions: {
          label: "占位符",
        },
        editor: false,
        defaultValue: _.get(field, "templateOptions.placeholder"),
      },
      {
        key: "editor",
        type: "checkbox",
        templateOptions: {
          label: "是否可编辑",
        },
        editor: true,
        defaultValue: _.get(field, "editor"),
      },
    ];

    return config;
  }

  //1、字符串
  private text(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.minLength",
        type: "numbers",
        templateOptions: {
          label: "最小长度",
        },
        defaultValue: _.get(field, "templateOptions.minLength"),
      },
      {
        key: "templateOptions.maxLength",
        type: "numbers",
        templateOptions: {
          label: "最大长度",
        },
        defaultValue: _.get(field, "templateOptions.maxLength"),
      },
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //2、多语言
  private textI18N(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];
    return config;
  }
  //3、多行文本
  private textArea(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.minLength",
        type: "numbers",
        templateOptions: {
          label: "最小长度",
        },
        defaultValue: _.get(field, "templateOptions.minLength"),
      },
      {
        key: "templateOptions.maxLength",
        type: "numbers",
        templateOptions: {
          label: "最大长度",
        },
        defaultValue: _.get(field, "templateOptions.maxLength"),
      },
      {
        key: "templateOptions.rows",
        type: "numbers",
        templateOptions: {
          label: "默认行数",
        },
        defaultValue: _.get(field, "templateOptions.rows"),
      },
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //4、数字
  private number(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.min",
        type: "numbers",
        templateOptions: {
          label: "最小值",
        },
        defaultValue: _.get(field, "templateOptions.min"),
      },
      {
        key: "templateOptions.max",
        type: "numbers",
        templateOptions: {
          label: "最大值",
        },
        defaultValue: _.get(field, "templateOptions.max"),
      },
      {
        key: "templateOptions.precision",
        type: "numbers",
        templateOptions: {
          label: "精度",
        },
        defaultValue: _.get(field, "templateOptions.precision"),
      },
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //5、密码
  private passWord(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.minLength",
        type: "numbers",
        templateOptions: {
          label: "最小长度",
        },
        defaultValue: _.get(field, "templateOptions.minLength"),
      },
      {
        key: "templateOptions.maxLength",
        type: "numbers",
        templateOptions: {
          label: "最大长度",
        },
        defaultValue: _.get(field, "templateOptions.maxLength"),
      },
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];
    return config;
  }

  //6、单选
  private radio(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }
  //6、单选
  private radioGroup(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }
  //7、复选
  private checkbox(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //8、下拉
  private select(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //9、日期
  private datetime(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //10、图片
  private image(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //11、附件
  private upload(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "checkbox",
        templateOptions: {
          label: "是否必填",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }

  //12、弹框
  private lookup(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [];

    return config;
  }

  //13、html
  private html(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [];

    return config;
  }

  //14、html
  private repeat(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.minLength",
        type: "numbers",
        templateOptions: {
          label: "最少几条",
        },
        defaultValue: _.get(field, "templateOptions.minLength"),
      },
      {
        key: "templateOptions.maxLength",
        type: "numbers",
        templateOptions: {
          label: "最多几条",
        },
        defaultValue: _.get(field, "templateOptions.maxLength"),
      },
      {
        key: "templateOptions.type",
        type: "radiogroup",
        templateOptions: {
          label: "显示方式",
          parameterid: "para001",
          options: [
            {
              label: "块状",
              value: "default",
            },
            {
              label: "列表",
              value: "table",
            },
          ],
        },
        defaultValue: _.get(field, "templateOptions.type"),
      },
    ];

    return config;
  }

  private dimissContract(field: KreFormFieldConfig) {
    let config: KreFormFieldConfig[] = [
      {
        key: "templateOptions.required",
        type: "dimissContract",
        templateOptions: {
          label: "",
        },
        defaultValue: _.get(field, "templateOptions.required"),
      },
    ];

    return config;
  }
}
